/* tslint:disable */
/* eslint-disable */
export enum WorkAccountingExportKindEnum {
  SupplierInvoice = 'supplier_invoice',
  GeneralLedgerEntry = 'general_ledger_entry',
  Attachment = 'attachment',
  Partner = 'partner'
}
